import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const apolloIo = defineConnector({
  identifier: "apolloIo",
  name: "Apollo.io",
  tagLine: "Sales intelligence platform",
  logo,
  protocol: "http",
  tags: ["productivity", "data"],
  defaultUrlPattern: () => "https://api\\.apollo\\.io/.*",
  auth: (app) => headerAuth([{ name: "X-Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your Apollo.io API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Apollo.io, go to **Settings > Integrations > API Keys** and create a new API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.apollo.io/v1/auth/health",
  },
});
